<header class="tm-header-wrapper">
    <div class="container">
        <div class="tm-header">
            <div class="header-nav">
                <div class="header-logo cursor-pointer" (click)="goToHome()">
                    <span class="svg-icon" [svgIcon]="'logoMain'"></span>
                </div>
                <ul class="menu-list">
                    <li>
                        <a routerLink="/home" routerLinkActive="active">{{ 'HEADER.HOME' | translate }}</a>
                    </li>
                    <li>
                        <a routerLink="/teacher-add" routerLinkActive="active">
                         {{ 'HEADER.JOIN_PLATFORM' | translate }}
                        </a>
                    </li>
                </ul>
            </div>
            <div class="header-toolbar">
              


                <button type="button" class="btn tm-btn btn-language" (click)="toggleLanguage();">
                    <span class="svg-icon" [svgIcon]="'global'"></span>
                    {{ 'TRANSLATOR.language' | translate }}
                </button>
            </div>
        </div>
    </div>
</header>